/* eslint-disable quote-props */
import React from 'react';
import { Script } from 'gatsby';
// eslint-disable-next-line
import { useLocation } from '@reach/router';

export enum DniBrand {
    INVOCA = 'INVOCA',
}

interface DniProviderReturnable {
    provider: DniBrand,
    numberMap: Record<string, string>
}

const DniContext = React.createContext(null as unknown as DniProviderReturnable);

const InvocaRuntime = (): JSX.Element => (
    <Script
        id="invoca"
        dangerouslySetInnerHTML={{
            __html: `
                        (function (i, n, v, o, c, a) {
                          i.InvocaTagId = o;
                          var s = n.createElement('script');
                          s.type = 'text/javascript';
                          s.async = true;
                          s.src = ('https:' === n.location.protocol ? 'https://' : 'http://') + v;
                          var fs = n.getElementsByTagName('script')[0];
                          fs.parentNode.insertBefore(s, fs);
                        })(window, document, 'solutions.invocacdn.com/js/invoca-latest.min.js', '1905/2238540922');
                      `,
        }}
    />
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DniProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
    const { pathname } = useLocation();
    const provider = DniBrand.INVOCA;

    const trigger = React.useCallback((): void => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (provider === DniBrand.INVOCA && (window as any).Invoca) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any).Invoca.PNAPI.run();
        }
    }, [provider]);

    /*
    * Run automatically when provider changes
    * */
    React.useEffect(() => {
        trigger();
    }, [provider, trigger, pathname]);

    const value = React.useMemo(() => ({
        provider,
        trigger,
        numberMap: {},
    }), [provider, trigger]);

    return (
        <DniContext.Provider value={value}>
            {children}
            <InvocaRuntime />
        </DniContext.Provider>
    );
};

export const useDniProvider = (): DniProviderReturnable => {
    const ctx = React.useContext(DniContext);
    if (!ctx) {
        throw new Error('No DNI Context has been provided.');
    }
    return ctx;
};

export default DniProvider;
